import React from "react";
import data from "../../Data/Data.json";
import Section from "../Section/Section";
import Link from "../../Assets/icons/Link";
import Folder from "../../Assets/icons/Folder";
export default function Projects() {
  const projects = [
    {
      id: 0,
      title: data.projects.ecommerceWebsite,
      link: "https://quantum-quik-shop.vercel.app/",
      github: "https://github.com/Malaya47/QuantumQuikShop",
      desc: "Developed a modern, full-stack e-commerce application using the MERN stack (MongoDB, Express.js, React, Node.js).The project demonstrates proficiency in both frontend and backend development with industry standard practices.",
      tech: [
        "JavaScript",
        "React",
        "Node",
        "Express.js",
        "Axios",
        "Redux Toolkit",
        "MongoDB",
        "React-router",
        "Bootstrap",
        "Git",
      ],
    },
    {
      id: 1,
      title: data.projects.socialMedia,
      link: "https://quantum-verse-frontend.vercel.app/login",
      github: "https://github.com/Malaya47/Quantum-Verse",
      desc: "Architected and developed a feature-rich social media platform using the MERN stack (MongoDB, Express.js, React.js, Node.js), implementing modern web development practices and real-time interactions.",
      tech: [
        "JavaScript",
        "React",
        "Node",
        "Express.js",
        "Axios",
        "Redux Toolkit",
        "MongoDB",
        "React-router",
        "Bootstrap",
        "Git",
      ],
    },
    // {
    //   id: 2,
    //   title: data.projects.youtube,
    //   link: "https://github.com/aniketnimkar/youtube-clone",
    //   desc: "This YouTube clone project aims to recreate the core functionality of YouTube by fetching and displaying data from the YouTube API. It serves as a practice exercise for developers to work with APIs, focusing on data retrieval and presenting video content within the application. By building this clone, developers can enhance their web development skills and gain hands-on experience in implementing key features of a video-sharing platform.",
    //   tech: [
    //     "JavaScript",
    //     "React",
    //     "React Router",
    //     "Tailwind CSS",
    //     "Git",
    //     "Parcel",
    //     "Varcel",
    //   ],
    // },
    // {
    //   id: 3,
    //   title: data.projects.todoList,
    //   link: "https://github.com/aniketnimkar/to-do-App",
    //   desc: "A todo app project is a software application that helps users manage their tasks and to-do lists. The app typically allows users to create tasks, set due dates and priorities, categorize tasks, and mark tasks as completed when they are finished.",
    //   tech: ["JavaScript", "HTML", "CSS", "Git"],
    // },
    // {
    //   id: 4,
    //   title: data.projects.weather,
    //   link: "https://www.github.com/abhiapatel/px-to-rem",
    //   desc: "A weather web app is a type of web application that allows users to get information about the weather in real time. These apps typically use APIs (Application Programming Interfaces) to retrieve weather data from the Open weather map.",
    //   tech: ["HTML", "CSS", "JavaScript", "API", "Netlify", "Github"],
    // },
  ];

  return (
    <Section
      className="projects"
      id="projects"
      title={data.projects.projectsTitle}
    >
    <h1 class="uppercase text-lg leading-6 tracking-widest text-slate-200">{data.projects.projectHeading}</h1>
      <div className="grid lg:grid-cols-1 md:grid-cols-2 gap-10 text-md leading-6 text-slate-400">
        {projects.map((project) => {
          return (
            <div
              className="grid gap-7 p-6 bg-[#112240] shadow-lg rounded-lg"
              key={project.id}
            >
              <div className="flex items-center justify-between">
                <Folder />
                <div className="flex"> 
                <a href={project.link} target="_blank" rel="noreferrer">
                  <Link />
                </a>
                 <a href={project.github} target="_blank" rel="noreferrer" className="ml-2">
                  {/* <Link /> */}
                  GitHub
                </a>
                </div>
              </div>
              <div className="flex flex-col gap-2">
                <h1 className="text-white text-xl">{project.title}</h1>
                <span>{project.desc}</span>
                <code className="mt-5 text-sm text-slate-300">
                  {project.tech.slice(",").join(" ")}
                </code>
              </div>
            </div>
          );
        })}
      </div>
    </Section>
  );
}
